import { ExamLayoutConfig } from './ExamLayoutConfig';
export default ExamLayoutConfig;
